<script setup>
import { Loc } from 'main.core';
import { storeToRefs } from 'ui.vue3.pinia';
import CalculatorParam from './CalculatorParam.vue';
import InfoBlock from './InfoBlock.vue';
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();
const { tariffsAvailable } = storeToRefs(calculator);
</script>

<template>
  <CalculatorParam>
    <template #title>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_TARIFF') }}
    </template>
    <template #subtitle>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_PERIOD_HINT') }}
    </template>
    <div class="cloud-calculator__tariffs">
      <label
        class="cloud-calculator__tariff"
        v-for="tariff in tariffsAvailable"
        :key="tariff.id"
        :for="`cloud-calculator-tariff-${tariff.id}`"
      >
        <input
          type="radio"
          name="cloud-calculator-tariff"
          :value="tariff.id"
          :id="`cloud-calculator-tariff-${tariff.id}`"
          :checked="calculator.selectedTariff === tariff.id"
          @change="calculator.selectedTariff = tariff.id"
          :disabled="!tariff.available"
        >
        <div class="cloud-calculator__tariff-content">
          <span class="cloud-calculator__tariff-name">{{ tariff.name}}</span>
          <div class="cloud-calculator__tariff-description" v-if="tariff.description">
            {{ tariff.description }}
          </div>
        </div>
      </label>
    </div>
    <InfoBlock :modifiers="['mark', 'info']">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_TARIFFS') }}
    </InfoBlock>
  </CalculatorParam>
</template>
